<template>
  <div class="supplierSelfEvaluation">
    <el-row>
      <PickupPlantMulti v-if="templateList!=null&&templateList.length > 0" @pick-up="addPlant" :disabled="disabled" :five-bit-code="fiveBitCode" :categoryLevel1Code='fiveBitCodeObj.categoryLevel1Code' :categoryLevel2Code='fiveBitCodeObj.categoryLevel2Code' :categoryLevel3Code='fiveBitCodeObj.categoryLevel3Code' :fiveBitCodeName='fiveBitCodeObj.fiveBitCodeName'></PickupPlantMulti>
    </el-row>
    <el-form :model="tableHeadData" ref="tableForm" style="margin-top:20px">
      <el-table :data="templateList" border row-key="templateDetailId" ref="scoreTable" max-height="700" :span-method="spanMethod" :row-class-name="rowClassNameFun" :cell-class-name="cellClassNameFun">
        <el-table-column :label="$t('sensory.template.detailName')" fixed="left" prop="title" width="160" align="center"></el-table-column>
        <el-table-column :label="$t('sensory.template.criterion')" class-name="template-detail" min-width="500px">
          <template slot-scope="scope" style="padding: 0">
            <div v-if="scope.row.detailType == 'TITLE'">{{scope.row.detail}}</div>
            <div v-else-if="scope.row.detailType == 'SCORE'">{{scope.row.detail}}</div>
            <div v-else>
              <div v-if="scope.row.isComments == 'Y'">{{scope.row.detail}}</div>
              <div v-if="scope.row.isComments != 'Y'">
                <div class="template-detail-cell row1" v-for="i in 9" :key="i">
                  {{scope.row.detail.split('`')[i-1]==''?" 　":scope.row.detail.split('`')[i-1]}}
                </div>
                <div>
                  <div class="template-detail-cell row2" v-for="i in 9" :key="i">
                    {{(scope.row.start > i||scope.row.end < i)?"  ":i}}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-for="(plant,plantIndex) in tableHeadData" :key="'plant'+plantIndex" header-align="center" min-width="600px">
          <template slot="header" slot-scope="scope">
            <pickup-plant :five-bit-code="fiveBitCode" :disabled="disabled || plant.status == 'SUBMIT'" v-model="tableHeadData[plantIndex].plantName" :plantName.sync="tableHeadData[plantIndex].plantName" @pick-up="changePlant($event,plantIndex)" style="vertical-align: middle;width: calc(100% - 30px);"></pickup-plant>
            <el-button v-if="!disabled" type="danger" icon="el-icon-minus" circle size="mini" @click="delPlant(plantIndex)" class='miniButton'></el-button>
          </template>
          <el-table-column header-align="center">
            <template slot="header" slot-scope="scope">
              <span style='margin-right:10px'>{{$t('sensory.report.batchNo')}}</span>
              <el-button v-if="!disabled" @click="addBatch(plantIndex)" type="primary" icon="el-icon-plus" size="mini" circle class='miniButton'></el-button>
            </template>
            <el-table-column v-for="(batch,batchIndex) of plant.batches" :key="batchIndex">
              <template slot="header" slot-scope="scope">
                <div class='batchesColumn'>
                  <el-form-item :rules="batchRules.batchNo" :prop="`[${plantIndex}].batches[${batchIndex}].batchNo`" class="batchNoView">
                    <el-input :disabled="disabled || plant.status == 'SUBMIT'" style="vertical-align:middle;" v-model="tableHeadData[plantIndex].batches[batchIndex].batchNo"></el-input>
                  </el-form-item>
                  <!-- <el-input :disabled="disabled || plant.status == 'SUBMIT'" style="width: calc(100% - 30px);vertical-align: middle;" v-model="batch.batchNo"></el-input> -->
                  <el-button v-if="!disabled" @click="delBatch(plantIndex,batchIndex)" type="danger" size="mini" icon="el-icon-minus" circle class='miniButton'></el-button>
                </div>

              </template>
              <el-table-column v-for="(user,userIndex) of batch.users" :key="user.ttSensoryClbPlantBatchId" header-align="center">
                <template slot="header" slot-scope="scope">
                  <span style='margin-right:10px'>{{$t('sensory.calibration.user')}}</span>
                  <el-button v-if="!disabled" @click="addUser(plantIndex,batchIndex)" type="primary" icon="el-icon-plus" size="mini" circle class='miniButton'></el-button>
                </template>
                <el-table-column align="center" :min-width="200">
                  <template slot="header" slot-scope="scope">
                    <el-input style="vertical-align: middle;width: calc(100% - 40px)" @blur="userNameTrim(user)" :disabled="!((action=='SP_EDIT' && plant.status != 'SUBMIT')||action=='CQS_EDIT')" v-model="user.userName"></el-input>
                    <el-button v-if="!disabled" @click="delUser(plantIndex,batchIndex,userIndex)" type="danger" size="mini" icon="el-icon-minus" circle class='miniButton'></el-button>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item style="display: inline-block" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments == 'Y'" :prop="`[${plantIndex}].batches[${batchIndex}].users[${userIndex}].scores[${scope.row.ttTemplateDetailId}]`" :rules="scoreRules.score2">
                      <el-input type="textarea" :disabled="disabled || plant.status == 'SUBMIT'" v-model="user.scores[scope.row.ttTemplateDetailId]" :placeholder='scoresPlaceholder(disabled)'></el-input>
                    </el-form-item>

                    <el-form-item style="width:120px;display: inline-block" autocomplete="off" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments != 'Y'" :prop="`[${plantIndex}].batches[${batchIndex}].users[${userIndex}].scores[${scope.row.ttTemplateDetailId}]`" :rules="scoreRules.score">
                      <el-input style="width: 50px;" class="score" :max="scope.row.end" :min="scope.row.start" :disabled="disabled || plant.status == 'SUBMIT'" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments != 'Y'" v-model="tableHeadData[plantIndex].batches[batchIndex].users[userIndex].scores[scope.row.ttTemplateDetailId]"></el-input>
                    </el-form-item>
                    <span v-if="scope.row.detailType == 'SCORE'">{{countScore(scope.row.scoreField,user)}}</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-form>
    <FileUpload :disabled="disabled" @input="changeFiles" rec-type="SENSORY_CALIBRATION" :seq="1" :biz-id="ttSensoryCalibrationId" v-model="subFiles" style="margin-top:20px"></FileUpload>
  </div>
</template>

<script>
import commonFun from "@/utils/commonFun";
import { Message } from "element-ui";
import FileUpload from "@/components/common/fileUpload";
import icSelect from "@/components/common/icSelect";
import PickupPlant from "@/components/page/sensory/pickupPlant";
import PickupPlantMulti from "@/components/page/sensory/pickupPlantMulti";

export default {
  name: "supplierSelfEvaluation",
  components: { PickupPlantMulti, PickupPlant, FileUpload, icSelect },
  props: {
    plantBatchSpList: {
      type: Object,
      default: [],
    },
    fiveBitCode: {
      type: String,
      default: "",
    },
    ttSensoryCalibrationId: {
      type: Number,
      default: {}
    },
    templateList: {
      type: Object,
      default: []
    },
    files: {
      type: Object,
      default: []
    },
    action: {
      type: String,
      default: ""
    },
    fiveBitCodeObj: {}
  },
  created() {
    this.initTableHeadData();
  },
  data() {
    var validatorBatchNo = (rule, value, callback) => {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      }
      if (!/^[0-9]{8,11}$/gi.test(value)) {
        return callback(new Error("只能输入8~11位数字"));
      }
      callback();
    };
    var validatorScore2 = (rule, value, callback) => {
      if (value && value.indexOf("；") != -1) {
        return callback(new Error("不能输入分号"));
      }
      if (value && value.indexOf(";") != -1) {
        return callback(new Error("不能输入分号"));
      }
      if (value && value.indexOf(".") != -1) {
        return callback(new Error("不能输入句号"));
      }
      if (value && value.indexOf("。") != -1) {
        return callback(new Error("不能输入句号"));
      }
      if (value) {
        var arr = value.split(/[(|（].*?[）|)]/);
        arr.some(function (value, index) {
          if (value.indexOf(" ") != -1 || value.indexOf("　") != -1) {
            return callback(new Error("内容中不能输入空格"));
          }
        })

      }
      callback();
    };
    return {
      subFiles: this.files,
      scoreRules: {
        score: [{ type: 'number', validator: this.scoreRange, trigger: ["change", "blur"] }],
        score2: [{ type: 'number', validator: validatorScore2, trigger: ["change", "blur"] }]
      },
      tableHeadData: [],
      appearanceIndex: null,
      textureIndex: null,
      flavorIndex: null,
      showPickupPlantDialog: false,
      batchRules: {
        batchNo: [{ type: 'number', validator: validatorBatchNo, trigger: ["change", "blur"] }]
      },
    }
  },
  methods: {
    scoresPlaceholder(val) {
      return val ? "" : "多值请用逗号分隔      例如:1(内容),2(内容)"
    },
    scoreRange(rule, value, callback) {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("common.canNotBeEmpty")));
      }
      let reg = /\[(\d)+\]/g;
      let templateDetailIndex = null;
      let res = null;
      while (res = reg.exec(rule.field)) {
        templateDetailIndex = res[0].substr(1, res[0].length - 2);
      }
      let templateDetail = this.templateList.filter(templateDetail => templateDetail.ttTemplateDetailId == templateDetailIndex)[0];
      let start = templateDetail.start;
      let end = templateDetail.end;
      if (Number.isNaN(value - 0) || value < start || value > end) {
        return callback(new Error(this.$t("sensory.report.scoreRangeErr", { start: start, end: end })));
      } else {
        return callback();
      }
    },
    changeFiles(files) {
      this.$emit("update:files", files);
    },
    validate() {
      let haveError = false;
      let tableHeadData = this.tableHeadData;
      if (commonFun.isEmpty(tableHeadData)) {
        Message.error(this.$t("sensory.report.plantCannotBeEmpty"));
        haveError = true;
      }
      if (!haveError && commonFun.isEmpty(this.templateList)) {
        Message.error(this.$t("sensory.report.pleaseMaintainTemplateFirst"));
        haveError = true;
      }
      if (!haveError) {
        tableHeadData.every(plant => {
          if (commonFun.isEmpty(plant.tmPlantId)) {
            Message.error(this.$t("sensory.report.plantCannotBeEmpty"));
            haveError = true;
            return false;
          } else if (tableHeadData.filter(tmpPlant => tmpPlant.tmPlantId == plant.tmPlantId).length > 1) {
            Message.error(this.$t("sensory.report.plantCannotBeSame"));
            haveError = true;
            return false;
          }
          let batches = plant.batches;
          batches.forEach(batch => {
            if (commonFun.isEmpty(batch.batchNo)) {
              Message.error(this.$t("sensory.report.batchNoCannotBeEmpty"));
              haveError = true;
              return false;
            } else if (batches.filter(tmpBatch => tmpBatch.batchNo == batch.batchNo).length > 1) {
              Message.error(this.$t("sensory.report.batchNoCannotBeSame"));
              haveError = true;
              return false;
            }
            let users = batch.users;
            users.forEach(user => {
              if (commonFun.isEmpty(user.userName)) {
                Message.error(this.$t("sensory.report.userNameCannotBeEmpty"));
                haveError = true;
                return false;
              }
            })
          })
        });
      }
      if (haveError) {
        return new Promise(function (resolve, reject) {
          resolve(false);
        });
      }
      let that = this;
      let then = that.$nextTick().then(() => {
        return that.$refs.tableForm.validate();
      });
      return then.then();
    },
    initTableHeadData() {
      let tableHeadData = [];
      this.tableHeadData = [];
      if (commonFun.isEmpty(this.plantBatchSpList)) {
        return;
      }
      this.plantBatchSpList.forEach(userInfo => {
        let plant = null;
        let batch = null;
        let user = null;
        if (tableHeadData.filter(plant => plant.tmPlantId == userInfo.tmPlantId).length > 0) {
          plant = tableHeadData.filter(plant => plant.tmPlantId == userInfo.tmPlantId)[0];
        } else {
          plant = {
            calibrationPlantId: userInfo.calibrationPlantId,
            plantName: userInfo.plantName,
            tmPlantId: userInfo.tmPlantId,
            batches: [],
            status: userInfo.status
          }
          tableHeadData.push(plant);
        }
        if (plant.batches.filter(batch => batch.batchNo == userInfo.batchNo).length > 0) {
          batch = plant.batches.filter(batch => batch.batchNo == userInfo.batchNo)[0];
        } else {
          batch = {
            batchNo: userInfo.batchNo,
            users: []
          }
          plant.batches.push(batch);
        }

        user = {
          ttSensoryClbPlantBatchId: userInfo.ttSensoryClbPlantBatchId,
          ttSensoryClbDetailId: userInfo.ttSensoryClbDetailId,
          userName: userInfo.userName,
          scores: {}
        }
        userInfo.clbDetailList.forEach(clbDeatil => {
          user.scores[clbDeatil.templateDetailId] = commonFun.isEmpty(clbDeatil.score) ? undefined : clbDeatil.score;
        })
        batch.users.push(user);
      });
      this.tableHeadData = tableHeadData;
      let that = this;
      that.$nextTick(() => {
        that.$refs["scoreTable"].doLayout();
        that.$forceUpdate();
      })
    },
    addPlant(plants) {
      if (commonFun.isEmpty(this.templateList)) {
        Message.error(this.$t('sensory.calibration.pleaseSelectProduct'));
        return;
      }

      let that = this;
      if (commonFun.isEmpty(this.tableHeadData)) {
        this.tableHeadData = [];
      }
      if (commonFun.isNotEmpty(plants)) {
        plants.forEach(plantData => {
          let exists = false;
          if (that.tableHeadData.filter(plant => plant.tmPlantId == plantData.tmPlantId).length > 0) {
            exists = true;
          }
          if (exists) {
            return true;
          }
          let plant = {
            calibrationPlantId: null,
            plantName: plantData.plantName,
            tmPlantId: plantData.tmPlantId,
            batches: [{
              ttSensoryClbPlantBatchId: null,
              ttSensoryClbDetailId: null,
              templateDetailId: null,
              batchNo: null,
              users: [{
                userName: null,
                scores: {},
              }]
            }]
          };
          plant.batches.forEach(batch => {
            batch.users.forEach(user => {
              that.templateList.filter(template => commonFun.isNotEmpty(template.ttTemplateDetailId)).forEach(template => {
                user.scores[template.ttTemplateDetailId] = undefined;
              })
              user.scores
            })
          })
          that.tableHeadData.push(plant);
        })
      }

      that.$nextTick(() => {
        that.$refs["scoreTable"].doLayout();
      })
    },
    delPlant(plantIndex) {
      let that = this;
      if (that.tableHeadData.length <= 1) {
        Message.warning(that.$t("sensory.report.plantCannotEmpty"));
        return;
      }
      that.$confirm(that.$t("common.delConfirm"), 'Message', {
        confirmButtonText: that.$t('common.confirm'),
        cancelButtonText: that.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        that.$delete(that.tableHeadData, plantIndex);
      });
    },
    changePlant(material, plantIndex) {
      let that = this;
      that.$set(this.tableHeadData[plantIndex], 'plantName', material.plantName);
      that.$set(this.tableHeadData[plantIndex], 'tmPlantId', material.tmPlantId);
    },
    addBatch(plantIndex) {
      console.log(plantIndex)
      let that = this;
      if (commonFun.isEmpty(this.tableHeadData[plantIndex].batches)) {
        this.tableHeadData[plantIndex].batches = [];
      }
      let batches = this.tableHeadData[plantIndex].batches;
      let batch = {
        ttSensoryClbPlantBatchId: null,
        ttSensoryClbDetailId: null,
        templateDetailId: null,
        batchNo: null,
        users: [{
          userName: null,
          scores: {},
        }]
      }
      batches.push(batch);
      this.$set(this.tableHeadData[plantIndex].batches, batches);
      that.$nextTick(() => {
        that.$refs["scoreTable"].doLayout();
      })
    },
    delBatch(plantIdex, batchIndex) {
      let that = this;
      that.$confirm(that.$t("common.delConfirm"), 'Message', {
        confirmButtonText: that.$t('common.confirm'),
        cancelButtonText: that.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        if (that.tableHeadData[plantIdex].batches.length == 1) {
          that.delPlant(plantIdex);
          // that.$delete(that.tableHeadData, plantIdex);
        } else {
          that.$delete(that.tableHeadData[plantIdex].batches, batchIndex);
        }
      });
    },
    changeBatchNo(val, plantIndex, batchIndex) {
      this.$set(this.tableHeadData[plantIndex].batches[batchIndex], "batchNo", val);
    },
    addUser(plantIndex, batchIndex) {
      let that = this;
      let user = {
        userName: null,
        scores: {},
      };
      let users = that.tableHeadData[plantIndex].batches[batchIndex].users;
      users.push(user);
      that.$set(that.tableHeadData[plantIndex].batches[batchIndex].users, users);
      that.$set(that.templateList, that.templateList);
      that.$nextTick(() => {
        that.$refs["scoreTable"].doLayout();
      })
    },
    delUser(plantIndex, batchIndex, userIndex) {
      let that = this;
      that.$confirm(that.$t("common.delConfirm"), 'Message', {
        confirmButtonText: that.$t('common.confirm'),
        cancelButtonText: that.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        if (that.tableHeadData[plantIndex].batches[batchIndex].users.length == 1) {
          that.delBatch(plantIndex, batchIndex);
        } else {
          that.$delete(that.tableHeadData[plantIndex].batches[batchIndex].users, userIndex);
        }
      });
      this.$refs["scoreTable"].doLayout();
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      let userSize = 0;
      if (commonFun.isNotEmpty(this.tableHeadData)) {
        this.tableHeadData.forEach(plantData => {
          plantData.batches.forEach(batchData => {
            batchData.users.forEach(value => {
              userSize++;
            })
          });
        });
        if (row.detailType == 'TITLE' && columnIndex == 1) {
          return [1, 1 + userSize]
        }
      } else {
        return [1, 1];
      }
    },
    cellClassNameFun({ row, column, rowIndex, columnIndex }) {
      if (row.detailType == 'TITLE') {
        if (columnIndex == 0) {
          return "title";
        } else if (columnIndex == 1) {
          return "title-desc";
        }
      } else if (row.isComments == 'Y') {
        return "detail-comments"
      }
    },
    rowClassNameFun({ row, rowIndex }) {
      if (row.detailType == 'TITLE') {
        return "title";
      }
    },
    userNameTrim: function (user) {
      if (commonFun.isNotEmpty(user.userName)) {
        user.userName = user.userName.trim();
      } else {
        user.userName = '';
      }
    }
  },
  computed: {
    disabled() {
      return this.action != 'SP_EDIT';
    },
    countScore() {
      let that = this;
      return (scoreField, batch) => {
        let detailType = null;
        switch (scoreField) {
          case 'AppearanceScore':
            detailType = "APPEARANCE";
            break;
          case 'TextureScore':
            detailType = "TEXTURE";
            break;
          case 'FlavorScore':
            detailType = "FLAVOR";
            break;
          case 'QualityScore':
            detailType = "ALL";
            break;
        }
        let scores = that.templateList.filter(templatDetail => {
          return templatDetail.isComments != 'Y';
        }).filter(templatDetail => {
          if (detailType == "ALL") {
            return templatDetail.detailType == "APPEARANCE" || templatDetail.detailType == "TEXTURE" || templatDetail.detailType == "FLAVOR";
          } else {
            return templatDetail.detailType == detailType;
          }
        }).map(templatDetail => {
          return batch.scores[templatDetail.ttTemplateDetailId];
        });
        let count19 = scores.filter(value => value == 1 || value == 9).length;
        let count28 = scores.filter(value => value == 2 || value == 8).length;
        let count37 = scores.filter(value => value == 3 || value == 7).length;
        let count46 = scores.filter(value => value == 4 || value == 6).length;
        let count5 = scores.filter(value => value == 5).length;
        let score = null;
        if (count19 > 0) {
          score = 0;
        } else if (count28 > 0) {
          score = 25;
        } else if (count37 > 0) {
          score = 60 + (count5 > 0 ? (count5 / (scores.length - 1) * 20) : 0) + (count46 > 0 ? (count46 / (scores.length - 1) * 10) : 0);
        } else if (count46 > 0) {
          score = 85 + (count5 > 0 ? (count5 / (scores.length - 1) * 10) : 0);
        } else if (count5 > 0) {
          score = 100;
        }
        if (null != score) {
          return score.toFixed(1) + "%";
        }
      };
    },
    plantNames() {
      if (commonFun.isNotEmpty(this.tableHeadData)) {
        return this.tableHeadData.map(plant => plant.plantName).join(";");
      } else {
        return "";
      }
    }
  },
  watch: {
    files(val) {
      this.subFiles = val;
    },
    templateList(newValue, oldValue) {
      this.$refs["scoreTable"].doLayout();
    },
    fiveBitCode(newVal, oldValue) {
      console.log(this.fiveBitCode)
      if (newVal != oldValue) {
        if (commonFun.isNotEmpty(this.tableHeadData)) {
          this.tableHeadData = [];
        }
        // else {
        //     this.addPlant();
        // }
      }
    },
    plantBatchSpList(newVal) {
      this.initTableHeadData();
    },
    plantNames(newVal) {
      this.$emit("change-plants", newVal);
    },
    fiveBitCodeObj() {
      console.log(this.fiveBitCodeObj)
    },
    batchNoChenge(e) {
      console.log(e)
    }

  },
}
</script>
<style scope lang="scss">
.supplierSelfEvaluation {
  textarea {
    resize: none;
  }
  .el-button--mini.is-circle.miniButton {
    padding: 0px;
  }
  .template-detail {
    padding: 0 !important;
  }

  // .el-table .cell {
  //   padding: 0 !important;
  // }

  .el-table td .cell {
    min-height: 40px;
  }
  .el-table {
    td:not(.template-detail),
    td.detail-comments,
    td.title,
    td.title-desc {
      .cell {
        line-height: 40px;
      }
    }
  }

  .template-detail-cell {
    width: 11.11111%;
    display: inline-block;
    text-align: center !important;
  }

  /*.template-detail-cell.row1:not(:first-child){border-left:1px solid #EBEEF5; }*/
  .template-detail-cell.row2 {
    border-top: 1px solid #ebeef5;
  }

  .template-detail-cell.row2:not(:first-child) {
    border-left: 1px solid #ebeef5;
  }

  tr.title td {
    font-weight: bold;
    font-style: oblique;
  }

  .plant-select {
    width: calc(100% - 30px);
    vertical-align: middle;
  }

  .el-table thead.is-group th {
    padding: 2px 0;
  }

  .el-table th div {
    line-height: 32px !important;
  }

  .el-table--small td,
  .el-table--small th {
    padding: 0 !important;
  }

  .score input {
    text-align: center;
  }

  .el-form-item__error {
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
  }
  .batchNoView .el-form-item__error {
    left: 50%;
    transform: translate(-50%, 0px);
    width: 100%;
    margin-top: -5.5px;
  }
  .batchNoView {
    padding: 0;
    overflow: visible;
    width: 100%;
    .el-form-item__content {
      padding: 0;
      overflow: visible;
      width: 100%;
    }
    .el-form-item__error {
      line-height: initial !important;
    }
  }
  .batchesColumn {
    display: flex;
    .miniButton {
      width: 14px;
      height: 14px;
      margin-top: 10px;
    }
  }
}
</style>
